import type { BlocDefinition } from './bloc-definition';
import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SPLASHSCREENIMAGEMODALBLOCK_LEGACY_FIELD_ORDER = [
  "content",
  "url",
  "max_width",
  "max_height",
  "close_delay",
  "close_icon_color",
  "close_icon_background_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  splashScreenImageModalBlockDescriptor: _generatedSplashScreenImageModalBlockDescriptor,
  splashScreenImageModalBlockModalDefinition,
  splashScreenImageModalBlockDashboardLayout,
  splashScreenImageModalBlockConfig,
  splashScreenImageModalBlockResolveConfig,
  splashScreenImageModalBlockProperties,
} = doodModalConfig(
  {
    name: "Splash screen image modal",
    handle: "splash-screen-image-modal",
    internal_name: "SplashScreenImageModalBlock",
    componentType: 'SplashScreenImageModalBlockComponent',
    category: 'modal',
    description: "Splash screen image modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "splash-screen-image-modal",
    sharedFields: {}
  },

  () => ({
    content: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: 'pages.blocks.splash-screen-image-modal.content.label',
        help: 'pages.blocks.splash-screen-image-modal.content.help',
      }
    }),
    url: propertyValue({
      type: 'text',
      value: '',
      options: {
        "label": "Redirect to url"
      }
    }),
    max_width: propertyValue({
      type: 'text',
      value: '100dvw',
      options: {
        "max_length": 100,
        "label": "Max Width"
      }
    }),
    max_height: propertyValue({
      type: 'text',
      value: '100dvh',
      options: {
        "max_length": 100,
        "label": "Max Height"
      }
    }),
    close_delay: propertyValue({
      type: 'text',
      value: '',
      options: {
        "label": "Délai de fermeture (en secondes)"
      }
    }),
    close_icon_color: propertyValue({
      type: 'color',
      value: { type: 'palette', value: 'primary-900' },
      options: {
        label: 'pages.blocks.splash-screen-image-modal.close-icon-color.label',
      },
    }),
    close_icon_background_color: propertyValue({
      type: 'color',
      value: { type: 'palette', value: 'primary-200' },
      options: {
        label: 'pages.blocks.splash-screen-image-modal.close-icon-background-color.label',
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: 'pages.blocks.splash-screen-image-modal.tab.content.label',
        fieldsets: [
          {
            legend: 'pages.blocks.splash-screen-image-modal.fieldset.display.label',
            fields: [
              "content",
              "url",
              "max_width",
              "max_height",
              "close_delay",
              "close_icon_color",
              "close_icon_background_color",
            ],
          },
        ],
      },
    ],
  })
);

/**
 * CB2 page picker entry. The journey Modals tab keeps
 * `splashScreenImageModalBlockModalDefinition` (category `modal`).
 */
export const splashScreenImageModalBlockBlocDefinition: BlocDefinition = {
  type: splashScreenImageModalBlockModalDefinition.type,
  name: splashScreenImageModalBlockModalDefinition.name,
  category: 'content',
  description: 'pages.blocks.splash-screen-image-modal.description',
  keywords: splashScreenImageModalBlockModalDefinition.keywords ?? [],
  propertyGroups: splashScreenImageModalBlockModalDefinition.propertyGroups,
  allowedIn: [{ bloc: '*Page', slot: '*' }],
};

export function splashScreenImageModalBlockDescriptor(): IBlockDescriptor;
export function splashScreenImageModalBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function splashScreenImageModalBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSplashScreenImageModalBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedSplashScreenImageModalBlockDescriptor, splashScreenImageModalBlockProperties, fieldOrder);
}

export {
  splashScreenImageModalBlockModalDefinition,
  splashScreenImageModalBlockDashboardLayout,
  splashScreenImageModalBlockProperties,
  splashScreenImageModalBlockConfig,
  splashScreenImageModalBlockResolveConfig,
};

export type SplashScreenImageModalBlockConfig = typeof splashScreenImageModalBlockConfig;
